export { default as BasicModal } from './Basic';
export { default as ConfirmModal } from './Confirm';
export { default as Modal } from './Modal';



/** WEBPACK FOOTER **
 ** ./src/modals/index.js
 **/